import { errorMessage } from '../lib/api'

/** The third of the three states: not empty, not filtered out — broken. Always offer a retry. */
export function ErrorState({
  error,
  message,
  onRetry,
}: {
  error?: unknown
  message?: string
  onRetry?: () => void
}) {
  return (
    <div role="alert" className="rounded-lg border border-critical-ring/40 bg-critical-bg p-4 text-sm text-critical-fg">
      <span aria-hidden className="mr-1.5">●</span>
      {message ?? "Couldn't load this."}
      {error !== undefined && <span className="ml-1 opacity-80">{errorMessage(error)}</span>}
      {onRetry && (
        <button className="ml-2 font-medium underline" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  )
}
